import React, { useContext, useState } from "react"
import "./country.sass"
import { auHref, caHref } from "../utils/constant"
import { globalContext } from "./context"
import classNames from "classnames"

const Country = () => {
  const value = useContext(globalContext)

  const { intl, country, changeCountry } = value

  const [actived, setActived] = useState(false)

  const select = c => {
    changeCountry(c)
    setActived(false)
  }

  return (
    <div className="country-container">
      <div
        className={classNames("text-container", { active: actived })}
        onClick={() => {
          setActived(!actived)
        }}
      >
        {intl.formatMessage({ id: `global.${country}` })}
        <i className="arrow" />
      </div>
      <div className={classNames("dropdown-menu", { active: actived })}>
        <a className="dropdown-item" onClick={() => select("ca")} href={caHref}>
          {intl.formatMessage({ id: "global.ca" })}
        </a>
        <a className="dropdown-item" onClick={() => select("us")} href={caHref}>
          {intl.formatMessage({ id: "global.us" })}
        </a>
        <a className="dropdown-item" href={auHref} onClick={() => select("au")}>
          {intl.formatMessage({ id: "global.au" })}
        </a>
      </div>
    </div>
  )
}

export default Country
